import { GameElementSpecificationsInterface } from "../../interfaces/game-element-specifications-interface";
import { AlingString, ColorsString, GameFontStylesString, textFontSize } from "../../settings/game-constants-strings/text-styles-string";

export const StartSceneElementsSpecifications: GameElementSpecificationsInterface[] = [
    {
        type: 'image',
        element: 'background',
        assetName: 'main-scene-background',
        name: 'main-scene-background',
        scale: {
            objectWidthRatio: 1,
            objectHeightRatio: 1,
            objectWidth: 1366,
            objectHeight: 770,
            objectPositionX: 683,
            objectPositionY: 384,
        }
    },
    {
        type: 'image',
        element: 'background',
        assetName: 'modal-scene-background',
        name: 'scene-backgroud',
        scale: {
            objectWidthRatio: 1,
            objectHeightRatio: 1,
            objectWidth: 1366,
            objectHeight: 770,
            objectPositionX: 683,
            objectPositionY: 384,
        }
    },
    {
        type: 'text',
        element: 'title',
        name: 'game-title',
        content: 'REBOTE',
        style: {
            fontFamily: GameFontStylesString.SMALL_FONT,
            color: ColorsString.LIGHT_GRAY_HEXADECIMAL_STRING,
            align: AlingString.CENTER_STRING,
            fontSize: textFontSize.VeryBig.fontSize,
            stroke: ColorsString.LIGHT_GRAY_HEXADECIMAL_STRING,
            strokeThickness: 9,
        },
        scale: {
            objectWidthRatio: 1,
            objectHeightRatio: 1,
            objectWidth: 734,
            objectHeight: 236,
            objectPositionX: 683,
            objectPositionY: 85,
        }
    },
    {
        type: 'button',
        element: 'button',
        assetName: 'play-button-background',
        name: 'play-button',
        content: 'JUGAR',
        style: {
            fontFamily: GameFontStylesString.BASE_FONT,
            color: ColorsString.WHITE_HEXADECIMAL_STRING,
            align: AlingString.CENTER_STRING,
            fontSize: textFontSize.ExtraBig.fontSize,
            strokeThickness: 3,
            stroke: ColorsString.WHITE_HEXADECIMAL_STRING
        },
        scale: {
            objectWidthRatio: 1,
            objectHeightRatio: 1,
            objectWidth: 360,
            objectHeight: 345,
            objectPositionX: 683,
            objectPositionY: 348,
        },
    },
    {
        type: 'button',
        element: 'button',
        assetName: 'red-button-background',
        name: 'help-button',
        content: 'AYUDA',
        style: {
            fontFamily: GameFontStylesString.BASE_FONT,
            color: ColorsString.WHITE_HEXADECIMAL_STRING,
            align: AlingString.CENTER_STRING,
            fontSize: textFontSize.LittleBig.fontSize,
            strokeThickness: 2,
            stroke: ColorsString.WHITE_HEXADECIMAL_STRING
        },
        scale: {
            objectWidthRatio: 1,
            objectHeightRatio: 1,
            objectWidth: 360,
            objectHeight: 165,
            objectPositionX: 265,
            objectPositionY: 700,
        },
    },
    {
        type: 'button',
        element: 'button',
        assetName: 'green-button-background',
        name: 'info-button',
        content: 'INFO',
        style: {
            fontFamily: GameFontStylesString.BASE_FONT,
            color: ColorsString.WHITE_HEXADECIMAL_STRING,
            align: AlingString.CENTER_STRING,
            fontSize: textFontSize.LittleBig.fontSize,
            strokeThickness: 2,
            stroke: ColorsString.WHITE_HEXADECIMAL_STRING
        },
        scale: {
            objectWidthRatio: 1,
            objectHeightRatio: 1,
            objectWidth: 360,
            objectHeight: 165,
            objectPositionX: 683,
            objectPositionY: 700,
        },
    },
    {
        type: 'button',
        element: 'button',
        assetName: 'blue-button-background',
        name: 'web-page-button',
        content: 'PÁGINA\nWEB',
        style: {
            fontFamily: GameFontStylesString.BASE_FONT,
            color: ColorsString.WHITE_HEXADECIMAL_STRING,
            align: AlingString.CENTER_STRING,
            fontSize: textFontSize.Regular.fontSize,
            strokeThickness: 2,
            stroke: ColorsString.WHITE_HEXADECIMAL_STRING
        },
        scale: {
            objectWidthRatio: 1,
            objectHeightRatio: 1,
            objectWidth: 360,
            objectHeight: 165,
            objectPositionX: 1108,
            objectPositionY: 700,
        },
    },
]